import { createClient } from '@urql/vue';

export default createClient({
  url: '/api/graphql',
});
